import { render, staticRenderFns } from "./WeMedia.vue?vue&type=template&id=5877cc35&scoped=true"
import script from "./WeMedia.vue?vue&type=script&lang=js"
export * from "./WeMedia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5877cc35",
  null
  
)

export default component.exports